import axios from "axios";

export const getCsrfToken = () => {
  const value = `; ${document.cookie}`;
  const parts = value.split("; csrftoken=");

  if (parts.length !== 2) {
    return null;
  }

  return parts.pop().split(";").shift() || null;
};

export const ensureCsrfToken = async () => {
  let token = getCsrfToken();

  if (token) {
    return token;
  }

  await axios.get("/api/csrf/", {
    withCredentials: true,
  });

  token = getCsrfToken();

  if (!token) {
    throw new Error(
      "The CSRF endpoint responded but did not create the csrftoken cookie."
    );
  }

  return token;
};

// Canonical transport contract for Django session-authenticated mutations.
export const csrfMutationConfig = async () => ({
  withCredentials: true,
  headers: {
    "X-CSRFToken": await ensureCsrfToken(),
  },
});
